"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _ComparisonDataDisplay = require("../../ComparisonDataDisplay.styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ColorSpec = _ref => {
  let {
    value,
    showColorToolTip = false,
    productId
  } = _ref;
  return value.colorValue && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 2
    }
  }, showColorToolTip ? /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.StyledTooltip, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tooltip, {
    id: `${productId}-${value.colorValue}`,
    appearance: "primary",
    text: value.text,
    size: 1
  }, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.ColorSwatchContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ColorSwatch, {
    color: value.colorValue,
    size: 4
  })))) : /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.ColorSwatchContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ColorSwatch, {
    color: value.colorValue,
    size: 4
  })));
};
var _default = ColorSpec;
exports.default = _default;